var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0938 0.650391H3.90625C1.74889 0.650391 0 2.39928 0 4.55664V36.7441C0 38.9015 1.74889 40.6504 3.90625 40.6504H36.0938C38.2511 40.6504 40 38.9015 40 36.7441V4.55664C40 2.39928 38.2511 0.650391 36.0938 0.650391Z",
    fill: "url(#paint0_linear_235_1171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9251 5.85059H24.4751C23.4396 5.85059 22.6001 6.69005 22.6001 7.72559V21.4756C22.6001 22.5111 23.4396 23.3506 24.4751 23.3506H32.9251C33.9606 23.3506 34.8001 22.5111 34.8001 21.4756V7.72559C34.8001 6.69005 33.9606 5.85059 32.9251 5.85059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5252 5.85059H7.0752C6.03966 5.85059 5.2002 6.69005 5.2002 7.72559V31.4756C5.2002 32.5111 6.03966 33.3506 7.0752 33.3506H15.5252C16.5607 33.3506 17.4002 32.5111 17.4002 31.4756V7.72559C17.4002 6.69005 16.5607 5.85059 15.5252 5.85059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_1171",
    x1: 2000,
    y1: 0.650391,
    x2: 2000,
    y2: 4000.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.650391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo7);
export default __webpack_public_path__ + "static/media/logo7.0d6e90431bd67813ad6f0660ba50b9ce.svg";
export { ForwardRef as ReactComponent };